<template>
  <v-expansion-panels v-model="panel">
    <v-expansion-panel>
      <v-expansion-panel-header>
        {{ $t('ITEM.CREATE') }} {{ $t('TILES.ITEM_GROUP') }}
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row>
          <v-col cols="12">
            <tiles-group-form
              v-model="group"
              :errors="errors.getAll()"
              @update-prop="clearErrorByName($event)"
            >
              <template #buttons="{ valid }">
                <v-btn
                  outlined
                  depressed
                  large
                  color="grey"
                  @click="$emit('cancel')"
                >
                  {{ $t('BUTTON.CANCEL') }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  large
                  depressed
                  color="success"
                  :disabled="!valid"
                  @click="store"
                >
                  {{ $t('BUTTON.SAVE') }}
                </v-btn>
              </template>
            </tiles-group-form>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { mapActions } from 'vuex';
import errors from '@/modules/_global/mixins/errors';

export default {
  name: 'TilesGroupCreate',

  components: {
    TilesGroupForm: () => import('./TilesGroupForm')
  },

  mixins: [errors],

  props: {
    applicationId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      group: {},
      panel: 0
    };
  },

  methods: {
    ...mapActions('tile', ['storeTilesGroup']),
    store() {
      this.storeTilesGroup({
        applicationId: this.applicationId,
        tilesGroup: this.group
      })
        .then(({ data }) => {
          this.$emit('created', data);
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }
  }
};
</script>
